import { ArrowUpRight } from "lucide-react";
import { CARS_IMG, BIKES_IMG } from "../../lib/site";
import { Reveal, Overline } from "./ui";

const cats = [
  {
    tag: "01 — Four Wheels",
    title: "Self-Drive Cars",
    desc: "Hatchbacks & SUVs. Clean, regularly serviced, with manual and automatic options for city and highway.",
    points: ["Hatchbacks & SUVs", "Manual / Automatic", "Serviced weekly"],
    img: CARS_IMG,
  },
  {
    tag: "02 — Two Wheels",
    title: "Bikes & Scooters",
    desc: "Scooters for quick city commutes and rugged touring motorcycles built for local mountain roads.",
    points: ["Scooters & Tourers", "Fuel efficient", "Helmet included"],
    img: BIKES_IMG,
  },
];

export default function Fleet() {
  return (
    <section className="relative bg-ink px-5 py-24 md:px-10 md:py-32">
      <div className="mx-auto max-w-[1400px]">
        <Reveal className="mb-14 max-w-3xl">
          <Overline>The Fleet</Overline>
          <h2 className="mt-4 font-heading text-3xl font-bold uppercase tracking-tight text-white sm:text-4xl md:text-5xl">
            Two ways to roam the hills
          </h2>
        </Reveal>

        <div className="grid grid-cols-1 gap-6 md:grid-cols-2">
          {cats.map((c, i) => (
            <Reveal key={c.title} delay={i * 0.12}>
              <div className="group relative h-[460px] overflow-hidden border border-white/10 md:h-[560px]">
                <img
                  src={c.img}
                  alt={c.title}
                  className="absolute inset-0 h-full w-full object-cover transition-transform duration-700 ease-out group-hover:scale-105"
                />
                <div className="absolute inset-0 bg-gradient-to-t from-ink via-ink/40 to-transparent" />
                <div className="relative flex h-full flex-col justify-end p-7 md:p-9">
                  <span className="text-xs font-bold uppercase tracking-[0.25em] text-volt">{c.tag}</span>
                  <h3 className="mt-3 font-heading text-3xl font-black uppercase tracking-tight text-white md:text-4xl">
                    {c.title}
                  </h3>
                  <p className="mt-3 max-w-md text-sm text-white/70 md:text-base">{c.desc}</p>
                  <div className="mt-5 flex flex-wrap gap-2">
                    {c.points.map((p) => (
                      <span key={p} className="border border-white/15 px-3 py-1 text-[11px] font-semibold uppercase tracking-wide text-white/80">
                        {p}
                      </span>
                    ))}
                  </div>
                  <a
                    href="#vehicles"
                    data-testid={`fleet-cta-${i}`}
                    className="mt-6 inline-flex w-fit items-center gap-2 text-sm font-bold uppercase tracking-wider text-volt"
                  >
                    Browse {c.title.split(" ")[1] || c.title} <ArrowUpRight size={16} />
                  </a>
                </div>
              </div>
            </Reveal>
          ))}
        </div>
      </div>
    </section>
  );
}
